import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import TopAddress from '../components/TopAddress';
import { setCartCount } from '../store/reducers/auth';
import { currencyData, wishsData } from '../utils/constants';
import { getFromLocalStorage, saveToLocalStorage } from '../utils/localStorageUtils';
import { getConvertedPrice, printLogs, saveItemObjInCart } from '../utils/Utilities';

import StaticPageHeader from '../components/common/StaticPageHeader';

const Wish = () => {

	const [wishs, setWishs] = useState(getFromLocalStorage(wishsData));
	const dispatch = useDispatch();
	let currency = getFromLocalStorage(currencyData);


	const handleDelete = (index) => {
		const updatedWishs = wishs.filter((_, i) => i !== index);
		setWishs(updatedWishs);
		saveToLocalStorage(wishsData, updatedWishs);
	};

	const btnAddToCartClick = (index) => {
		const wishDataItem = wishs[index];
		let result = saveItemObjInCart(wishDataItem);
		alert('Add to cart successfully');
		dispatch(setCartCount(result.cartCount));
	}

	printLogs('wish', wishs);

    return (
        <div className="static-page-wrapper bg-light min-vh-100 pb-5">
            <StaticPageHeader title="Personal Wishlist" />

            <div className="container static-page-container mt-4">
                <div className="row align-items-start mt-1">
                    <TopAddress />

                    <div className="col-12 col-md-8">
                        <div className="bg-white border shadow-sm p-4 p-md-5 mb-4" style={{ borderRadius: '12px' }}>
                            <h3 className="fw-bold text-dark mb-2" style={{ fontSize: '1.75rem' }}>Personal Wishlist</h3>
                            <p className="text-secondary mb-5">Keep track of items you love</p>
                            
                            {wishs && wishs.length > 0 ? (
                                <div className="row g-4">
                                    {wishs.map((wish, index) => {
                                        const item = wish;
                                        const variant = wish.selected_variant;
                                        const price = getConvertedPrice(variant.price);
                                        const salePrice = getConvertedPrice(variant.sale_price);
                                        const isSale = salePrice !== price ? 1 : 0;

                                        return (
                                            <div key={`wish-${index}`} className="col-xl-4 col-lg-6 col-md-6 col-sm-12">
                                                <div className="card h-100 border bg-white shadow-sm transition-hover" style={{ borderRadius: '12px', overflow: 'hidden' }}>
                                                    <div className="position-relative">
                                                        {isSale === 1 && (
                                                            <div className="badge bg-success text-white position-absolute m-2 px-2 py-1" style={{ top: 0, left: 0, zIndex: 1, letterSpacing: '0.5px' }}>
                                                                SALE
                                                            </div>
                                                        )}
                                                        <button onClick={() => handleDelete(index)} className="btn btn-light rounded-circle shadow-sm position-absolute m-2 d-flex align-items-center justify-content-center" style={{ top: 0, right: 0, zIndex: 1, width: '32px', height: '32px' }}>
                                                            <i className="fas fa-times text-danger"></i>
                                                        </button>
                                                        
                                                        <div className="bg-light" style={{ height: '200px', display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                                                            <img src={item.image} alt={item.name} className="img-fluid" style={{ maxHeight: '100%', objectFit: 'contain' }} />
                                                        </div>
                                                    </div>
                                                    
                                                    <div className="card-body p-3 d-flex flex-column">
                                                        <h6 className="fw-semibold text-dark mb-1 text-truncate">{item.name}</h6>
                                                        {item.selected_variant?.item_variant_attributes?.map((attr, idx) => (
                                                            <div key={idx} className="text-secondary small mb-1">
                                                                {attr.name}: <span className="fw-medium text-dark">{attr.item_attribute_value?.value}</span>
                                                            </div>
                                                        ))}
                                                        <div className="mt-2 mb-3">
                                                            <span className="fw-bold text-dark">{currency?.currency.symbol} {variant.sale_price}</span>
                                                            {isSale === 1 && (
                                                                <span className="text-muted small text-decoration-line-through ml-2">{currency?.currency.symbol} {variant.price}</span>
                                                            )}
                                                        </div>
                                                        
                                                        <div className="mt-auto">
                                                            <button onClick={() => btnAddToCartClick(index)} className="btn btn-outline-dark w-100 py-2 fw-medium" style={{ borderRadius: '6px' }}>
                                                                <i className="fas fa-shopping-cart mr-2"></i> Add to Cart
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            ) : (
                                <div className="col-12">
                                    <div className="p-5 text-center bg-light border" style={{ borderRadius: '12px' }}>
                                        <i className="fas fa-heart text-muted mb-4" style={{ fontSize: '3rem' }}></i>
                                        <h4 className="fw-bold text-dark mb-3">No Items in Wishlist</h4>
                                        <p className="text-secondary mb-4">You haven't saved any items yet. Explore our collection!</p>
                                        <Link to="/productlist" className="btn btn-dark px-4 py-2 fw-medium shadow-sm" style={{ borderRadius: '8px' }}>Start Shopping</Link>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Wish